module.exports = __webpack_public_path__ + "static/life-inc-logo-f14585e80f9006625977f7c1bb97a0c1.svg";